// User levels, ordered. TECH DEBT (see portfolio plan): today only `anonymous` and `admin` are
// produced, plus `registered` for a signed-in EntraID user without the Admin role. `unregistered`
// and the broader magic-link / Cognito mapping (and persisted profiles for demo features) are future
// — the rank + resolver are deliberately built to extend to all four levels without rework.
export type UserLevel = "anonymous" | "unregistered" | "registered" | "admin";

export const LEVEL_RANK: Record<UserLevel, number> = {
  anonymous: 0,
  unregistered: 1,
  registered: 2,
  admin: 3,
};

/** True when `level` is at least `min` in the hierarchy (use for gating). */
export function atLeast(level: UserLevel, min: UserLevel): boolean {
  return LEVEL_RANK[level] >= LEVEL_RANK[min];
}

export const ADMIN_ROLE = "Admin"; // App Role value on the EntraID app registration

export function resolveLevel(signedIn: boolean, roles: string[]): UserLevel {
  if (!signedIn) return "anonymous";
  if (roles.includes(ADMIN_ROLE)) return "admin";
  // signed-in EntraID user without Admin (an invited internal collaborator). Future: magic-link /
  // Cognito consumers also resolve here (registered) or to `unregistered`.
  return "registered";
}
